<template>
    <div class="pyramid-chart" >
        <div id="popup" style="display: none;" v-tippy-html>
            <div v-if="hoveredNode" class="popover-content">
                <h3>
                    Honorarios anuales
                    <template v-if="intervals[hoveredNode.interval].max">
                        entre {{numeral(intervals[hoveredNode.interval].min).divide(1000000).format('0,0')}} y {{numeral(intervals[hoveredNode.interval].max).divide(1000000).format('0,0')}} millones de pesos
                    </template>
                    <template v-else>
                        mayores a {{moneyFormatter(intervals[hoveredNode.interval].min)}}
                    </template>

                </h3>
                <h4>Número de Personas</h4>
                <div class="amount">{{numeral(hoveredNode.count).format('0,0')}} personas</div>
                <div class="percentage">{{numeral(hoveredNode.count / data.length).format('0.00%')}} del total</div>
                <br>
                <h4>Total en millones</h4>
                <div class="amount">{{moneyFormatter(hoveredNode.sum)}}</div>
                <div class="percentage">{{numeral(hoveredNode.sum / total).format('0.00%')}} del total</div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3">
                <div>Rango de Honorarios</div>
                <ul class="legend">
                    <li v-for="i in intervals.slice().reverse()">
                        <span class="key" :style="{background: color(i.key)}"></span>
                        <span class="description">> de {{numeral(i.min).format('$0,0')}}</span>
                    </li>
                </ul>
            </div>
            <div class="col-sm-9">
                <svg :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
                    <g>
                        <g v-for="d in computedData" class="pyramid-group" @click="detailClicked(d)" @mouseenter="hoveredNode = d" v-tippy="{html: '#popup', followCursor: true, arrow: true, animation: 'fade'}">
                            <path :d="line(d.coordinates)" :fill="color(d.interval)" stroke="white" stroke-width="2"></path>
                            <g v-if="boundingBox(d.coordinates).height > 80 && boundingBox(d.coordinates).width > 180" :transform="'translate('+center(d.coordinates).x+','+center(d.coordinates).y+')'" text-anchor="middle">
                                <text class="description">{{d.count}} personas</text>
                                <text class="amount" dy="30">{{numeral(d.sum / total).format('0.00%')}}</text>
                            </g>


                            <!--
                            <foreignObject :x="boundingBox(d.coordinates).x" :y="boundingBox(d.coordinates).y" :width="boundingBox(d.coordinates).width" :height="boundingBox(d.coordinates).height">
                                <body>
                                <div>{{d.count}} personas</div>
                                <div>{{numeral(d.sum / total).format('0.00%')}}</div>
                                </body>
                            </foreignObject>
                            -->
                        </g>
                    </g>
                </svg>
            </div>
        </div>

    </div>

</template>
<style lang="scss">
    .pyramid-chart{
        ul.legend{
            padding-left: 0;
            list-style: none;
            >li{
                background: #F7F7F7;
                padding: 5px;
                margin-top: 30px;
                border-radius: 4px;
                .key{
                    width: 16px;
                    height: 16px;
                    border-radius: 8px;
                    background: black;
                    display: inline-block;
                }
                .description{
                    display: inline-block;
                    font-size: 10px;
                    font-weight: 500;
                    text-transform: uppercase;
                }

            }
        }
        svg {
            width: 100%;
            height: auto;
            .pyramid-group{
                cursor: pointer;
                text{
                    fill: white;
                    &.description{
                        font-size: 16px;
                    }
                    &.amount{
                        font-size: 28px;
                    }
                }
            }
        }

    }
</style>
<script>
    import * as d3 from 'd3';
    import _ from 'lodash';
    import numeral from 'numeral';
    import moneyFormatter from '../../Methods/MoneyFormatter';

    const pyramid = function() {
        var size = [1,1],
            value = function(d) { return d.value},
            coordinates;

        var percentageValues = function (data) {
            var values = data.map(value);
            var sum = d3.sum(values, function (d){
                return +d;
            });
            var percentValues = data.map(function (d,i){
                d.value = +values[i];
                return values[i]/sum*100;
            });
            //percentValues.sort(function(a,b){
            //    return a-b;
            //});
            return percentValues;
        }
        var coordinatesCalculation = function(data){
            if(data.length === 0)
                return [];

            var w = size[0],
                h = size[1],
                ratio = (w/2)/h,
                percentValues = percentageValues(data),
                coordinates = [],
                area_of_triangle = (w * h) / 2;
            function d3Sum (i) {
                return d3.sum(percentValues,function (d, j){
                    if (j>=i) {
                        return d;
                    }
                });
            }
            for (var i=0,len=data.length;i<len; i++){
                var selectedPercentValues = d3Sum(i),
                    area_of_element = selectedPercentValues/100 * area_of_triangle,
                    height1 = Math.sqrt(area_of_element/ratio),
                    base = 2 * ratio * height1,
                    xwidth = (w-base)/2;

                if (i===0){
                    coordinates[i] = {"values":[{"x":w/2,"y":0},{"x":xwidth,"y":height1},{"x":base+xwidth,"y":height1}]};
                }else{
                    coordinates[i] = {"values":[coordinates[i-1].values[1],{"x":xwidth,"y":height1},{"x":base+xwidth,"y":height1},coordinates[i-1].values[2]]};
                }

            }

            coordinates[0].values[1] = coordinates[coordinates.length-1].values[1];
            coordinates[0].values[2] = coordinates[coordinates.length-1].values[2];
            coordinates.push(coordinates.shift());
            //var first_data = coordinates.splice(0,1);
            //coordinates = coordinates.reverse();
            //coordinates.splice(0,0,first_data[0]);
            return coordinates;
        }
        function pyramid(data) {
            var i = 0,
                coordinates = coordinatesCalculation(data);

            //data.sort(function(a,b) {
            //    return a.value - b.value;
            //})

            data.forEach(function(){
                data[i].coordinates = coordinates[i].values;
                i++;
            })
            return data;
        }
        pyramid.size = function(s){
            if(s.length === 2) {
                size = s;
            }
            return pyramid;
        }
        pyramid.value = function(v) {
            if (!arguments.length) return value;
            value = v;
            return pyramid;
        };
        return pyramid;
    };

    export default{
        data: function(){
            return {
                hoveredNode: null,
            }
        },
        props: {
            data: {},
            width: {default: 825},
            height: {default: 533},
            dimensions: {}
        },
        methods:{
            numeral: numeral,
            moneyFormatter: moneyFormatter,
            detailClicked: function(n){
                this.$emit('detail-clicked', n)
            },
            boundingBox: function(coordinates){
                let bbox = {x: {min: 999999, max: 0}, y: {min: 9999999, max: 0}}

                coordinates.forEach(d => {
                    if(d.x < bbox.x.min) bbox.x.min = d.x;
                    if(d.y < bbox.y.min) bbox.y.min = d.y;
                    if(d.x > bbox.x.max) bbox.x.max = d.x;
                    if(d.y > bbox.y.max) bbox.y.max = d.y;
                });

                return {x: bbox.x.min, y: bbox.y.min, width: bbox.x.max - bbox.x.min, height: bbox.y.max - bbox.y.min};
            },
            center: function(coordinates){
                const bbox = this.boundingBox(coordinates);
                return {
                    x: bbox.x + (bbox.width / 2),
                    y: bbox.y + (bbox.height / 2),
                }
            }
        },
        watch:{

        },
        computed:{
            total: function(){
                return _.sumBy(this.data, 'sum');
            },
            intervals: function(){
                if(this.data.length === 0)
                    return [];

                let segments = [];
                const nSegments = 8;
                const min = this.data[0].sum;
                const max = this.data[this.data.length - 1].sum;
                const intervalSize = Math.ceil(((max - min) / nSegments) / 1000000) * 1000000;

                let count = (Math.floor(min / 1000000) * 1000000) - 1;
                for(let i = 0; i < nSegments; i++){
                    segments.push({
                        key: i,
                        min: count + 1,
                        max: i < (nSegments-1) ? count + intervalSize : null
                    });
                    count = count + intervalSize;
                }

                return segments;


            },
            computedData: function(){
                let interval = this.intervals[0];
                const data = _(this.data)
                    .groupBy((d)=>{
                        if(interval.max !== null && d.sum > interval.max){
                            interval = this.intervals[interval.key + 1];
                        }
                        return interval.key;
                    })
                    .map((d, key)=>{
                        return {
                            interval: 1*key,
                            count: d.length,
                            sum: _.sumBy(d, 'sum'),
                            items: d
                        };
                    })
                    //.orderBy('interval', 'asc')
                    .value();

                //console.log(data);
                //return;

                return this.pyramid(data);
            },
            pyramid: function(){
                return pyramid()
                    .size([this.width,this.height])
                    .value(function(d) { return d.sum; });
            },
            line: function(){
                return d3.line()
                    .curve(d3.curveLinearClosed)
                    .x(function(d,i) { return d.x; })
                    .y(function(d,i) { return d.y; });
            },
            color: function(){
                return d3.scaleOrdinal(['#28A228','#1E90FF','#3455DB','#253494','#8A2BE2','#A745AD','#7A0177','#49006A'].reverse());
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Pyramid.vue